const dev = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "exa-content",
  },
  apiGateway: {
    REGION: "us-west-2",
    Gmail_URL: "https://2dksep313h.execute-api.us-west-2.amazonaws.com/prod",
    Contacts_URL: "https://sn073qrhp4.execute-api.us-west-2.amazonaws.com/prod",
    Notes_URL: "https://wog6mfbvfk.execute-api.us-west-2.amazonaws.com/prod",
    Users_URL: "https://gnuz5np16j.execute-api.us-west-2.amazonaws.com/prod",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_LSaH72iHx",
    APP_CLIENT_ID: "4u3m0r351ps1j98tuhp80i2gvp",
    IDENTITY_POOL_ID: "us-west-2:0158eef1-7e91-4a6b-8b0a-a1cb975e2411",
  },
};

const prod = {
  s3: {
    REGION: "us-west-2",
    BUCKET: "exa-content",
  },
  apiGateway: {
    REGION: "us-west-2",
    Gmail_URL: "https://2dksep313h.execute-api.us-west-2.amazonaws.com/prod",
    Contacts_URL: "https://sn073qrhp4.execute-api.us-west-2.amazonaws.com/prod",
    Notes_URL: "https://wog6mfbvfk.execute-api.us-west-2.amazonaws.com/prod",
    Users_URL: "https://gnuz5np16j.execute-api.us-west-2.amazonaws.com/prod",
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_LSaH72iHx",
    APP_CLIENT_ID: "4u3m0r351ps1j98tuhp80i2gvp",
    IDENTITY_POOL_ID: "us-west-2:0158eef1-7e91-4a6b-8b0a-a1cb975e2411",
  },
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js